var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn",
    staticStyle: {
      "max-height": "calc( 100vh - 150px)"
    }
  }, [_c('b-img', {
    staticClass: "chatflow",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "src": "static/img/chatflow.png",
      "alt": "ChatFlow"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a76f56","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Data.vue
// module id = 916
// module chunks = 1